/**
 * DpRangesService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DpRangesService {
    getAllDropDownValues = () => {
        return apiClient.get("/getmetric");
    }

    getRangesByMetric = (filter) => {
        return apiClient.get("/suggest_ranges/" + filter);
    }

    submitData = (body) => {
        return apiClient.post("/getmetric", body);
    }

    createRange = (body) => {
        return apiClient.post("/metric", body);
    }

    editRange = (body) => {
        return apiClient.post("/editmetric", body);
    }

    deleteRange = (id) => {
        return apiClient.post("/deletemetric", { id });
    }

    getMetricsOptions = () => {
        return apiClient.get("/getAllMetrics");
    }
}
